<template>
  <el-form-item
    :label="label || $t('ORGANIZATIONAL_UNIT')"
    :prop="prop"
    :rules="formRules"
    v-loading="loading"
    element-loading-spinner="el-icon-loading"
  >
    <el-select
      :disabled="disabled"
      v-model="selectValue"
      :clearable="allowsNone"
      filterable
      :placeholder="$t('SELECT_PLACEHOLDER')"
      :no-data-text="$t('NO_RESULT')"
      @change="handleChange"
      @clear="handleClear"
      @blur="handleBlur"
      @visible-change="handleVisibleChange"
    >
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { organizationalUnitChoices } from '@/api/acl'

export default {
  name: 'OrganizationalUnitSelect',
  props: {
    prop: {
      type: String,
      default: 'organizational_unit',
    },
    model: {
      type: [String, Number],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    resource: {
      type: String,
      required: true,
      validator: (value) => ['driver', 'vehicle', 'geofence'].includes(value),
    },
  },
  data() {
    return {
      options: [],
      selectValue: this.model,
      loading: true,
      allowsNone: true,
    }
  },
  computed: {
    formRules() {
      if (this.allowsNone) return []
      return [
        {
          required: true,
          message: this.$t('REQUIRED_CHOOSE', {
            type: this.label || this.$t('ORGANIZATIONAL_UNIT'),
          }),
          trigger: 'change',
        },
      ]
    },
  },
  methods: {
    handleChange(value) {
      this.selectValue = value
      this.$emit('update', value)
    },
    handleClear() {
      this.selectValue = null
      this.$emit('clear')
      this.$emit('update', null)
    },
    handleBlur() {
      this.$emit('blur')
    },
    handleVisibleChange(visible) {
      if (!visible) {
        this.$emit('blur')
      }
    },
    loadOptions() {
      this.loading = true
      organizationalUnitChoices.api(this.resource).then((res) => {
        if (res) {
          this.allowsNone = res.allows_none !== false
          this.options = res.units || []
        }
        this.loading = false
      })
    },
  },
  watch: {
    model: {
      handler(newVal) {
        this.selectValue = newVal
      },
      immediate: true,
    },
    resource() {
      this.loadOptions()
    },
  },
  created() {
    this.loadOptions()
  },
}
</script>
